<template>
  <div class="general-list">
    <div
      class="list-item after"
      v-for="(item, index) in list"
      :key="index"
      @click="listevent(item)"
    >
      <div class="list-logo">
        <img :src="item.C_LOGO" v-if="item.C_LOGO" />
      </div>
      <div class="list-content">
        <div class="list-title txt-two-line">
          {{ item.C_TITLE }}
        </div>
        <div class="list-text txt-four-line" v-html="item.C_ABSTRACT">
          {{ item.C_ABSTRACT }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "generalList",
  props: {
    list: {
      type: Array,
      default: [],
    },
  },
  methods: {
    listevent(item) {
      this.$emit("listevent", item);
    },
  },
};
</script>
<style lang="scss">

</style>